var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from "react";
import { PeekBox, PeekInput, PeekStack, PeekTooltip, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { Info as InfoIcon } from "@piiqtechnologies/svg-icons";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
const ManualAccessNameInput = (_a) => {
    var { label } = _a, props = __rest(_a, ["label"]);
    const theme = useTheme();
    const intl = useIntl();
    const [isFocused, setIsFocused] = React.useState(false);
    useEffect(() => {
        let timerId = null;
        if (isFocused) {
            timerId = window.setTimeout(() => {
                setIsFocused(false);
            }, 3500);
        }
        return () => !!timerId && clearTimeout(timerId);
    }, [isFocused]);
    return (React.createElement(PeekInput, Object.assign({}, props, { sx: {
            label: {
                display: "flex",
            },
        }, inputProps: {
            "data-testid": "access-device-name-input",
        }, onFocus: () => setIsFocused(true), label: React.createElement(PeekStack, { direction: "row", spacing: 0.5 },
            React.createElement(PeekTypography, { variant: "h4" }, label),
            React.createElement(PeekTooltip, { placement: "right", open: isFocused, "data-testid": "access-device-name-tooltip", title: React.createElement(PeekTypography, null, intl.formatMessage(messages.deviceNameTooltipTitle)) },
                React.createElement(PeekBox, { marginRight: `${theme.spacing(0.3)} !important`, onMouseEnter: () => setIsFocused(true), sx: {
                        svg: {
                            verticalAlign: "middle",
                        },
                    } },
                    React.createElement(InfoIcon, { height: 14, width: 14 })))) })));
};
export default ManualAccessNameInput;
